import { Component } from '@angular/core';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { IconCardConfig, LostAndFoundPageConfig } from 'src/app/interfaces/pageConfig';

@Component({
  selector: 'app-lost-and-found-v2',
  templateUrl: './lost-and-found-v2.component.html',
  styleUrl: './lost-and-found-v2.component.scss'
})
export class LostAndFoundV2Component {
  public page: LostAndFoundPageConfig;

  constructor(
    private configService: ConfigService,
    private authManager: AuthManagerService,
  ) {
    this.page = this.configService.getPage('lostAndFound');
  }

  public ctaTextFor(card: IconCardConfig): string {
    return this.authManager.isAuthenticated || !card.ctaTextUnauthenticated
      ? card.ctaText
      : card.ctaTextUnauthenticated;
  }
}
